// Temporary place for addresses so we don't leak keywords (ignition) in build
/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xCBA0C0a2a0B6Bb11233ec4EA85C5bFfea33e724d)
 */
export const ignitionAirdropRewardsAddress = {
  1: '0xCBA0C0a2a0B6Bb11233ec4EA85C5bFfea33e724d',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x7ac96180C4d6b2A328D3a19ac059D0E7Fc3C6d41)
 */
export const socialAndPreFarmingAirdropRewardsAddress = {
  1: '0x7ac96180C4d6b2A328D3a19ac059D0E7Fc3C6d41',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x9107F5f940226A9f21433F373A4f938228d20e1A)
 */
export const cookie3AirdropRewardsAddress = {
  1: '0x9107F5f940226A9f21433F373A4f938228d20e1A',
} as const
